"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Row = void 0;
const react_1 = __importDefault(require("react"));
const Row = ({ children, className = "", ...props }) => {
    return react_1.default.createElement("div", { className: `row ${className}`, ...props }, children);
};
exports.Row = Row;
